const SESSION_STORAGE_KEY = "hongding_seo_session_token";
const HASH_TOKEN_KEY = "session-token";

function safeStorage() {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function parseTokenFromHash(hash: string): string | null {
  const normalizedHash = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!normalizedHash) return null;

  const params = new URLSearchParams(normalizedHash);
  const token = params.get(HASH_TOKEN_KEY)?.trim();
  return token || null;
}

function removeTokenFromHash(): void {
  if (typeof window === "undefined") return;
  const currentUrl = new URL(window.location.href);
  const params = new URLSearchParams(currentUrl.hash.startsWith("#") ? currentUrl.hash.slice(1) : currentUrl.hash);
  if (!params.has(HASH_TOKEN_KEY)) return;

  params.delete(HASH_TOKEN_KEY);
  const nextHash = params.toString();
  const nextUrl = `${currentUrl.pathname}${currentUrl.search}${nextHash ? `#${nextHash}` : ""}`;
  window.history.replaceState({}, document.title, nextUrl);
}

export function getSessionToken(): string | null {
  const storage = safeStorage();
  if (!storage) return null;
  const token = storage.getItem(SESSION_STORAGE_KEY)?.trim();
  return token || null;
}

export function setSessionToken(token: string): void {
  const storage = safeStorage();
  if (!storage) return;
  storage.setItem(SESSION_STORAGE_KEY, token);
}

const clearLegacyStoredToken = () => {
  const storage = safeStorage();
  if (!storage) return;
  storage.removeItem(SESSION_STORAGE_KEY);
  try {
    window.sessionStorage.removeItem(SESSION_STORAGE_KEY);
  } catch {
    // ignore sessionStorage failures
  }
};

export async function initializeSessionBridge(_workerOrigin: string): Promise<void> {
  if (typeof window === "undefined") return;

  const hashToken = parseTokenFromHash(window.location.hash);
  if (hashToken) {
    setSessionToken(hashToken);
    removeTokenFromHash();
    return;
  }
}

export function clearSessionToken(): void {
  clearLegacyStoredToken();
}
